export const keyRowsEnglish = ['QWERTYUIOP', 'ASDFGHJKL', 'ZXCVBNM'];
export const keyRowsKorean = [
  'ㅂㅈㄷㄱㅅㅛㅕㅑㅐㅔ',
  'ㅁㄴㅇㄹㅎㅗㅓㅏㅣ',
  'ㅋㅌㅊㅍㅠㅜㅡ',
];
